import { render, staticRenderFns } from "./fullPinkBtn.vue?vue&type=template&id=81342fc4&scoped=true"
import script from "./fullPinkBtn.vue?vue&type=script&lang=js"
export * from "./fullPinkBtn.vue?vue&type=script&lang=js"
import style0 from "./fullPinkBtn.vue?vue&type=style&index=0&id=81342fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81342fc4",
  null
  
)

export default component.exports